import { useEffect, useState } from 'react'

import { fetchUserCardsApi } from '@api'
import { CameraCardTheme } from '@shared'

export interface UserCardsResponse {
  number: number
  description: string
  img: string
  id: string
  title: string
  mask: CameraCardTheme
}

export const useUserCameraCards = () => {
  const [cards, setCards] = useState<UserCardsResponse[] | null>(null)

  useEffect(() => {
    const loadCards = async () => {
      const { data: userCards } = await fetchUserCardsApi()
      // @ts-ignore
      const cards = userCards?.sort((a,b) => a.last_collected_at - b.last_collected_at).map((card) => ({
        number: card.count,
        description: card.description,
        img: card.icon,
        id: card.id,
        title: card.name,
        mask: 'SPIDERMAN',
      }))
      setCards((cards as UserCardsResponse[]) || null)
    }

    loadCards()
  }, [])

  return cards
}
